import { wagmiConfig as config, } from "@wagmiconfig";
import { getChainId, } from "wagmi/actions";
import { getTokenDefinition, getValidChainId,} from "@bracket/chainography";
import { amountToBigInt } from "../helpers";
import { ethToBrktETH, wethToBrktETH, } from "@bracket/contractor-next/brktETH-router";
import type { BuyProps, BuyResult, } from "./buy";



/**
 * Executes a swap operation to convert ETH/WETH to BRKTETH
 * @param {BuyProps} props - The swap parameters
 * @param {TokenIdentifier} props.tokenIn - The input token identifier (ETH or WETH)
 * @param {AmountString} props.amountIn - The amount of input token to swap
 * @param {AmountString} props.amountOut - The expected amount of BRKTETH to receive
 * @returns {Promise<BuyResult>} Result containing transaction hash or error
 * @throws {Error} If the swap operation fails
 */
export const swap = async ({
  tokenIn,
  amountIn,
  amountOut,
}: BuyProps): Promise<BuyResult> => {

  const tok = getTokenDefinition(tokenIn);
  const brkt = amountToBigInt(amountOut, getTokenDefinition({ symbol: "BRKTETH", chainId: getValidChainId(config), }));
  const eth = amountToBigInt(amountIn, tok);
  const token = getTokenDefinition(tokenIn);

  try {

    const { hash, } = token.symbol === "ETH"
      ? await ethToBrktETH({ brkt, eth, config, })
      : await wethToBrktETH({ brkt, amount: eth, config, });

    return {
      hash,
      error: undefined,
    }

  }
  catch (error) {

    return {
      hash: null,
      error: error instanceof Error ? error : new Error("no error provided"),
    }
    
  }

};
